module.exports = __webpack_public_path__ + "img/public/SiteIcons/menuIconNew.svg?7394d1c6";